<template>
  <div class="code">
    <div class="heading" v-if="showLabel">
      <label>{{ label || $t('sign_up.invitation_code')}} </label>
      <el-tooltip class="item" effect="light" :content="$t('sign_up.tooltip_message')" placement="right-start" :visible-arrow="false">
        <el-button>
          <img src="@/assets/images/tooltip.svg"/>
        </el-button>
      </el-tooltip>
    </div>
    <div class="code-group">
      <div class="elsa-input" v-for="item in parseInt(codeLength)" :key="item">
        <el-input class="code-input" v-bind="$attrs" v-model="inputValue[item - 1]" :maxlength="1" @change.native="onChange"/>
      </div>
    </div>
    <div class="el-form-item__error hidden" ref="error">
      {{ $t('sign_up.code_is_not_complete') }}
    </div>
  </div>
</template>

<script>
  import {
    any,
    either,
    isNil,
    isEmpty
  } from 'ramda'
  export default {
    props: {
      codeLength: {
        type: Number,
        default: 0
      },
      showLabel: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        inputValue: []
      }
    },
    methods: {
      onChange() {
        const isValid = this.checkIfCodeIsValid()
        if(isValid) {
          this.$refs.error.classList.add('hidden')
        } else {
          this.$refs.error.classList.remove('hidden')
        }
        this.$emit('codeChanged', { isValid: isValid, value: this.inputValue })
      },
      checkIfCodeIsValid() {
        const codeSize = this.inputValue.length
        const codeHaveEmptyValue = any(either(isNil, isEmpty))(this.inputValue)
        if (codeSize > 0 && codeSize < this.codeLength) {
          return false
        } else if(codeSize === 0 || (codeSize === this.codeLength && !codeHaveEmptyValue)) {
          return true
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/inputs';
  .code {
    text-align: initial;
    margin-top: 37px;
    margin-bottom: 16px;
    .heading {
      display: flex;
      align-items: flex-start;
      label {
        font-weight: 500;
        font-size: 18px;
        color: $dark-blue-2;
        margin-bottom: 8px;
      }
      .el-tooltip {
        padding: 0;
        border: none;
        background-color: transparent;
        margin-left: 2px;
      }
    }

    .el-form-item__error {
      position: relative;
      &.hidden {
        display: none;
      }
    }

    .code-group {
      display: inline-flex;
    }

    .elsa-input {
      margin-right: 5px;
      .el-input {
        width: 42px;
        &::v-deep .el-input__inner {
          padding: 0 10px;
          text-align: center;
          text-indent: 6px;
        }
      }
    }
  }
</style>
